<div class="db-add-website-migrate-only" dbCustomScrollbar>
  <div class="db-migrate-only__body" [ngClass]="{'db-new-onboarding': newOnboarding}">
    <div class="db-migrate-only__download">
      <h1 class="db-migrate-only__title-l"
          [innerHTML]="agencyFreelancer ? ('text_migrateClientsWebsite' | dbText) : ('text_migrateAndTestYour' | dbText)"></h1>
      <div>
        <img src="assets/images/migration/migrate_website_60-90_horizontal.png" alt="">
      </div>
      <div>
        <a class="db-button db-check-download" href="{{managerLink}}" (click)="downloadPlugin()" download>
          <img src="assets/images/icons/download.svg" alt=""> {{'text_download' | dbText}}
        </a>
        <div class="db-migrate-only__button-desc" [innerHTML]="'text_installationWontAffect' | dbText"></div>
      </div>
    </div>
    <div class="db-migrate-only__content">
      <h2 class="db-migrate-only__title-m">Free migration with no strings attached</h2>
      <div class="db-migrate-only__separate-line"></div>
      <p class="db-migrate-only__subtitle"
         [innerHTML]="agencyFreelancer ? ('text_migrateWebsiteFully'  | dbText ): ('text_migrateWebsiteFullySMB' | dbText)"></p>
      <!--<p *ngIf="!newOnboarding" class="db-migrate-only__subtitle">The live website won’t be affected in any way & you can delete
        your data anytime.</p>-->
      <div class="db-migrate-only__separate"></div>

      <!--<h3 class="db-migrate-only__title-s first" *ngIf="!newOnboarding"><img src="assets/images/icons/point.svg" alt="">Best Way to Explore
        10Web</h3>-->

      <!--<div *ngIf="!newOnboarding" class="db-migrate-only__section-wrap">
        <p class="db-migrate-only__text">Instead of a blank website, test the platform on a real one.</p>
        <div class="db-migrate-only__section">

          <ul class="db-migrate-only__checklist black-website">
            <li class="db-checklist-item"><span class="db-checklist-title">Blank WordPress website</span></li>
            <li class="db-checklist-item" *ngFor="let item of blankWebsite">
              <img src="assets/images/icons/checkmark_icon_2.svg" alt="">{{item}}
            </li>
          </ul>

          <ul class="db-migrate-only__checklist">
            <li class="db-checklist-item"><span class="db-checklist-title">{{agencyFreelancer ? 'Copy of your client’s website' : 'Copy of your website'}}</span></li>
            <li class="db-checklist-item" *ngFor="let item of copyWebsite">
              <img src="assets/images/icons/checkmark_icon_1.svg" alt="">{{item}}
            </li>
          </ul>
        </div>
      </div>-->

      <h3 class="db-migrate-only__title-s center"><img src="assets/images/icons/point.svg" alt="">How it works</h3>
      <div class="db-migrate-only__section-wrap">

        <p class="db-migrate-only__text center">10Web migration plugin will automatically create an optimized copy of your website on our hosting.</p>
        <div>
          <div class="db-migrate-only__section db-migration-steps">
            <div class="db-migration-step1">
              <img src="assets/images/icons/zip_download-new.png" alt="">
              <p class="db-migration-step-title"> Step 1 </p>
              <p class="db-migration-step-desc"> Download migration<br> plugin ZIP </p>
            </div>
            <div class="db-migration-step2">
              <img src="assets/images/icons/activate_plugin-new.png" alt="">
              <p class="db-migration-step-title"> Step 2 </p>
              <p class="db-migration-step-desc"> Install and<br> activate </p>
            </div>
            <div class="db-migration-step3">
              <img src="assets/images/icons/speed_score_90-new.png" alt="">
              <p class="db-migration-step-title"> Step 3 </p>
              <p class="db-migration-step-desc"> Test the platform & website<br> performance </p>
            </div>
            <a class="db-button db-check-download" href="{{managerLink}}" (click)="downloadPlugin()" download>
              <img src="assets/images/icons/download.svg" alt=""> {{'text_download' | dbText}}
            </a>
          </div>
          <div class="db-security-box">
              <img src="assets/images/icons/protection.svg" alt="">
            <div>
              <b>100,000 websites have already been securely migrated to 10Web with our plugin.</b>
              <p *ngIf="agencyFreelancer"> Installation of the plugin won’t<br class="ds-hide-desktop"> affect your client’s live website.</p>
              <p *ngIf="!agencyFreelancer"> Installation of the plugin won’t<br class="ds-hide-desktop"> affect your live website.</p>
            </div>
          </div>
        </div>
      </div>
      <h3 class="db-migrate-only__title-s center last">
        <img src="assets/images/icons/point.svg" alt="">
        {{agencyFreelancer ? 'Grow your business with 10Web' : 'Migrate to 10Web and benefit from:'}}
      </h3>
      <div class="db-migrate-only__section-wrap">
        <div class="db-migrate-only__section steps">
          <ul class="db-migrate-only__checklist steps">
            <li class="db-checklist-item" *ngFor="let item of offerFirstColumn">
              <img src="assets/images/icons/checkmark_icon_1.svg" alt="">{{item}}
            </li>
          </ul>
          <ul class="db-migrate-only__checklist steps">
            <li class="db-checklist-item" *ngFor="let item of offerSecondColumn">
              <img src="assets/images/icons/checkmark_icon_1.svg" alt="">{{item}}
            </li>
          </ul>
        </div>
      </div>
      <h3 class="db-migrate-only__title-s center last">
        <img src="assets/images/icons/point.svg" alt="">
        {{'text_get-pageSpeed-score' | dbText}}
      </h3>
      <div class="db-migrate-only__section-wrap">
        <div class="db-migrate-only__section steps">
          <ul class="db-migrate-only__checklist steps">
            <li class="db-checklist-title">{{optimizationService}} <span>Frontend Optimization</span></li>
            <li class="db-checklist-item" *ngFor="let item of offerThirdColumn">
              <img src="assets/images/icons/checkmark_icon_1.svg" alt="">{{item}}
            </li>
          </ul>
          <ul class="db-migrate-only__checklist steps">
            <li class="db-checklist-title">{{hostingService}} <span>Backend Optimization</span></li>
            <li class="db-checklist-item" *ngFor="let item of offerFourthColumn">
              <img src="assets/images/icons/checkmark_icon_1.svg" alt="">{{item}}
            </li>
          </ul>
        </div>
      </div>
      <a class="db-button db-check-download last" href="{{managerLink}}" (click)="downloadPlugin()" download>
        <img src="assets/images/icons/download.svg" alt=""> {{'text_download' | dbText}}
      </a>
    </div>
  </div>
</div>
